import { put, takeLatest, all, call } from 'redux-saga/effects';
import {
  setLoading,
  removeLoading,
  getItemFromLocalStorage,
  parseJwt,
} from '../../utils';
import { get, post, getLoc } from '../../api';
import {
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_SALON_LIST,
  GET_SALON_LIST_SUCCESS,
  UNRATED_APPOINTMENTS,
  UNRATED_APPOINTMENTS_SUCCESS,
  SUBMIT_RATING,
  SUBMIT_RATING_SUCCESS,
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
} from '../constants';
import {
  GET_CATEGORIES as GET_CATEGORIES_API,
  GET_SALON_LIST as GET_SALON_LIST_API,
  UNRATED_APPOINTMENTS as UNRATED_APPOINTMENTS_API,
  SUBMIT_RATING as SUBMIT_RATING_API,
} from '../../api/endpoints';

function* getCategories({ payload = {} }) {
  const location = getItemFromLocalStorage('location');
  if (location) {
    setLoading();
    const baseApi = `${GET_CATEGORIES_API}latitude=${
      location.latitude
    }&longitude=${location.longitude}&gender=${
      payload.gender ? payload.gender : 'male'
    }`;
    const userData = yield call(get, baseApi);
    if (window.location.href.indexOf('user-home') === -1) {
      yield call(getSalonList, {
        payload: {
          id: payload.id,
          gender: payload.gender || 'male',
        },
      });
    }
    removeLoading();
    yield put({ type: GET_CATEGORIES_SUCCESS, data: userData });
  }
}

function* getSalonList({ payload }) {
  setLoading();
  const { id, gender: genderFromReq } = payload;
  const location = getItemFromLocalStorage('location');
  if (location) {
    let baseApi = '';
    let { gender = '' } = parseJwt() || {};
    gender = gender || 'male';
    if (id) {
      baseApi = `${GET_SALON_LIST_API}latitude=${location.latitude}&longitude=${
        location.longitude
      }&category_id=${id}&gender=${genderFromReq || gender}`;
    } else {
      baseApi = `${GET_SALON_LIST_API}latitude=${location.latitude}&longitude=${
        location.longitude
      }&gender=${genderFromReq || gender}`;
    }
    const salonList = yield call(get, baseApi);
    yield put({ type: GET_SALON_LIST_SUCCESS, data: salonList.data.salons });
  }
  removeLoading();
}

function* getUnratedAppointments() {
  setLoading();
  const { user_id } = parseJwt();
  let baseApi = `${UNRATED_APPOINTMENTS_API}${user_id}/unrated_appointments`;
  const unratedAppointments = yield call(get, baseApi);
  removeLoading();
  yield put({
    type: UNRATED_APPOINTMENTS_SUCCESS,
    data: unratedAppointments.data.appointments,
  });
}

function* submitRating({ payload }) {
  setLoading();
  let baseApi = `${SUBMIT_RATING_API}${payload.salonId}/rate`;
  yield call(post, {
    endpoint: baseApi,
    params: payload.payload,
  });
  removeLoading();
  yield put({
    type: SUBMIT_RATING_SUCCESS,
  });
}

function* getLocation() {
  setLoading();
  const location = getItemFromLocalStorage('location');
  let baseApi = `https://api.opencagedata.com/geocode/v1/json?q=${location.latitude}+${location.longitude}&key=235d10c9aa3241a88e77892d89249c93`;
  let data = yield call(getLoc, baseApi);
  data = data || { results: [{}] };
  removeLoading();
  yield put({
    type: GET_LOCATION_SUCCESS,
    data: data.results[0].formatted,
  });
}

function* actionWatcher() {
  yield takeLatest(GET_CATEGORIES, getCategories);
  yield takeLatest(GET_SALON_LIST, getSalonList);
  yield takeLatest(UNRATED_APPOINTMENTS, getUnratedAppointments);
  yield takeLatest(SUBMIT_RATING, submitRating);
  yield takeLatest(GET_LOCATION, getLocation);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
